import React, { useEffect, useReducer, useState } from "react"
import AddNewProcedureCodes from "./AddNewProcedureCodes"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import Pagination from "../../../shared/Pagination/Pagination"
import Table from "../../Shared/Table"
import SearchHeader from "../../Shared/SearchHeader"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import MasterList from "../../Shared/MasterList"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import usePagination from "../../../../customhooks/usePagination"
const ProcedureCodes = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const API_Claim_URL = enumUtil.controller.Claim
    const [isOpenProcedure, setisOpenProcedure] = useState(false)
    const [ProcedureData, setProcedureData] = useState([]);
    const [ProcedureCode, setProcedureCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [isOpenMasterList, setisOpenMasterList] = useState(false)
    const [recent, setRecent] = useState(false)
    const [totalCounts, setTotalCounts] = useState(false)
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: false,  // set true if want to display cards as well
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    console.log("setting", Settings)
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////

    const LoadData = (param, types) => {
        setIsLoading(true)
        // setProcedureData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Procedure,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setProcedureData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setisOpenProcedure(true)
                }
            }
        }).catch((error) => {
            setProcedureData([])
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (ProcedureData?.length == 0 && isNull(searchParamType)) {
                    setisOpenProcedure(true)
                }
            }
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }

    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    const AddProcedure = (ID) => {
        setisOpenProcedure(true)
        setProcedureCode(ID)
    }
    const CloseProcedure = () => {
        setisOpenProcedure(false)
    }
    const DeleteProcedure = () => {
        setisOpenProcedure(false)
        setIsClose((Math.random()));
    }

    const handleRowSelection = (row) => {
        // console.log(row);
    }

    let PopupScreen = "";
    if (isOpenProcedure) {
        PopupScreen = <AddNewProcedureCodes isOpenProcedure={isOpenProcedure} onClose={CloseProcedure} onDeleteProcedure={DeleteProcedure} ProcedureCode={ProcedureCode} type={type} />
    }
    const CloseMasterList = () => {
        setisOpenMasterList(false)
        // setPOSCode(ID) 
    }
    let PopupScreenMasterList = "";
    if (isOpenMasterList) {
        PopupScreenMasterList = <MasterList isOpen={isOpenMasterList} onClose={CloseMasterList} type={type} />
    }
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleMasterList = () => {
        setisOpenMasterList(true)
    }

    const showRecentRecord = () => {
        setRecent(true)
        // setisOpenMasterList(true)
        setIsLoading(true)
        ServerRequestProtected(API_Claim_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Procedure,
            // "SearchParam": param,
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response })
            setProcedureData(response)
            // setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }
    const [copiedText, setCopiedText] = useState({});


    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [


        {
            key: 'ProcedureCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Procedure Code'} sortIcon={true} type={'string'} colKey={'ProcedureCode'} data={ProcedureData} setData={setProcedureData} />),
            renderCell: ({ row }) => {
                // console.log(row)
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddProcedure(row.ProcedureCodeID)}>{row.ProcedureCode} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ProcedureCodeID, row.ProcedureCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ProcedureCodeID}-${row.ProcedureCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'ShortName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Short Name'} sortIcon={true} type={'string'} colKey={'ShortName'} data={ProcedureData} setData={setProcedureData} />),
            flex: 1,
            renderCell: ({ row }) => {
                // console.log(row)
                return (
                    // <button className="btn btn-link w-100 p-0" >
                    <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                        <div className="validation_message" >{row.ShortName} </div>
                        {/* onClick={() => AddProcedure(row.ProcedureCodeID)} */}
                        {/* <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ProcedureCodeID, row.ProcedureCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div> */}
                        {/* {copiedText[`${row.ProcedureCodeID}-${row.ProcedureCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>} */}
                    </div>
                    //  </button>
                );
            },
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={ProcedureData} setData={setProcedureData} />),
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Description}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ProcedureCodeID, row.Description)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ProcedureCodeID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'Amount',
            name: 'Amount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Amount'} sortIcon={true} type={'number'} colKey={'Amount'} data={ProcedureData} setData={setProcedureData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (<>${row.Amount}</>);
            },
        },

        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={ProcedureData} setData={setProcedureData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={ProcedureData} setData={setProcedureData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },

    ]
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const ProcedureCodeBody = () => {
        return (
            <>
                <div className='container-fluid action-row br-clr'>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by Procedure Code or Description…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddProcedure}
                                masterListButton={handleMasterList}
                                showRecentRecord={showRecentRecord}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={633}
                                Name={'Procedures'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {isLoading ? <Loader /> : null}
                {show === false ?
                    <Table
                        columns={columns}
                        rows={ProcedureData}
                        height='500px'
                        rowClass={rowClass}

                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={633}
                        Name={'Procedures'}
                        isLoading={isLoading}
                        TableName={'Procedure'}
                        handleSelectData={handleSelectData}
                        LoadData={() => LoadData(searchParam)}
                        ClearSearch={handleClearSearch}
                    /> : null
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(ProcedureData?.length == 0 && isNull(searchParamType)){
    //             setisOpenProcedure(true)
    //         }       
    //     }
    // },[ProcedureData, searchParamType])
    return (
        <React.Fragment>
            {/* {PopupScreen}
            {PopupScreenMasterList} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {ProcedureData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenProcedure ? <>{PopupScreen}</> : isOpenMasterList ? <>{PopupScreenMasterList}</> : <>{ProcedureCodeBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenMasterList}
                    {ProcedureCodeBody()}
                </>
            }

        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(ProcedureCodes)